// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isNotEmptyField = (field?: string | number | any[] | Date): boolean => {
  if (field === undefined || field === null) {
    return false;
  }

  if (typeof field === "number") {
    return field !== 0;
  }
  if (Array.isArray(field)) {
    return field.length !== 0;
  }

  if (typeof field === "string") {
    const normalized = field.trim().toLowerCase();
    if (
      normalized === "" ||
      normalized === "0" ||
      normalized === "-" ||
      normalized === "keine angabe" ||
      normalized === "auf anfrage" ||
      normalized === "null"
    ) {
      return false;
    }
    return true;
  }

  return true;
};
